import { Capacitor } from "@capacitor/core";

const PROD_URL = "https://buukd.co";

export function getBaseUrl(): string {
  const publicSiteUrl = String(import.meta.env.VITE_PUBLIC_SITE_URL || "").replace(/\/+$/, "");
  if (publicSiteUrl) return publicSiteUrl;

  // In a Capacitor native app window.location.origin is "localhost" — always use the real prod URL.
  if (Capacitor.isNativePlatform()) return PROD_URL;

  if (typeof window === "undefined") return PROD_URL;

  return window.location.origin;
}
